import React, { useEffect } from 'react';
import './TeachingResources.css'
import SelectAudio from "./Dropdown"

function TeachingResources() {


  useEffect(() => {
    document.querySelector('body').style.backgroundColor = '#eadbd0'
  }, []);

  return (
    <div className="TeachingResourcesPage" >
      <h1 className="Title" >Teaching Resources</h1>
      <div className = "TeachingInfo">
        <h3>
          Use the drop down menu to search, select, and download Blackfoot audio recordings
        </h3>
      </div>
      <div className="TeachingInfo">
        <SelectAudio/>
      </div>
    </div>
  );
}

export default TeachingResources;